import { render, staticRenderFns } from "./PreviewSenType.vue?vue&type=template&id=0b39037d&"
import script from "./PreviewSenType.vue?vue&type=script&lang=js&"
export * from "./PreviewSenType.vue?vue&type=script&lang=js&"
import style0 from "./PreviewSenType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports